import { render, staticRenderFns } from "./jingjiren.vue?vue&type=template&id=0603f7f6&scoped=true&"
import script from "./jingjiren.vue?vue&type=script&lang=js&"
export * from "./jingjiren.vue?vue&type=script&lang=js&"
import style0 from "./jingjiren.vue?vue&type=style&index=0&id=0603f7f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0603f7f6",
  null
  
)

export default component.exports